<template>
    <div class="panel panel-body col-sm-8 col-sm-offset-2">
        <div class="text-center">
            <div class="icon-object border-slate-300 text-slate-300"><i class="fa fa-user-plus"></i></div>
            <h5 class="content-group">New customer <small class="display-block">Enter new credentials below</small></h5>
        </div>

        <div class="form-group has-feedback has-feedback-left">
            <input type="text" class="form-control" placeholder="E-mail" v-model="email">
            <div class="form-control-feedback">
                <i class="fa fa-user text-muted"></i>
            </div>
        </div>

        <div class="form-group has-feedback has-feedback-left">
            <input type="password" class="form-control" placeholder="Password" v-model="password">
            <div class="form-control-feedback">
                <i class="fa fa-lock text-muted"></i>
            </div>
        </div>

        <div class="form-group">
            <button class="btn bg-pink-400 btn-block" @click="processReg">Register <i class="fa fa-arrow-circle-o-right position-right"></i></button>
        </div>
    </div>
</template>
<script>
    import firebase from 'firebase'
    import swal from 'sweetalert2'

    export default {
        data () {
            return {
                email: '',
                password: ''
            }
        },
        methods: {
            processReg() {
                firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                    .then(function(user) {
                        console.log(user);
                        swal(
                            'Success!',
                            'Your account has been created!',
                            'success')
                    }, function(error) {
                        //var errorCode = error.code;
                        var errorMessage = error.message;
                            swal(
                                'Error!',
                                errorMessage,
                                'error');
                    });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Register.vue?157a93fe